import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MentorshipHero } from './sections/mentorship-hero/mentorship-hero';
import { MentorshipHowItWorks } from './sections/mentorship-how-it-works/mentorship-how-it-works';
import { MentorshipSchedule } from './sections/mentorship-schedule/mentorship-schedule';
import { MentorshipCommunity } from './sections/mentorship-community/mentorship-community';

@Component({
  selector: 'app-mentorship',
  imports: [
    MentorshipHero,
    MentorshipHowItWorks,
    MentorshipSchedule,
    MentorshipCommunity,
  ],
  templateUrl: './mentorship.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Mentorship {}
